"use client";
import {Tabs, TabsProps} from "antd";
import PersonalData from "@/components/center/account-information/personal-data";

const onChange = (key: string) => {
};

const items: TabsProps["items"] = [
    {
        key: "1",
        label: "个人资料",
        children: <PersonalData/>
    }
];

export default function UpdateInfo() {
    return <Tabs defaultActiveKey="1" items={items} onChange={onChange} className="!px-4 !pb-16"/>;
}
